module.exports = __webpack_public_path__ + "static/media/dhabicoin.6c4e7e61.webp";